<template>
  <div>
    <div v-if="fieldsToRender">
      <div class="row"
        v-for="row in Object.keys(fieldsToRender)"
        :key="`row-${row}`"
      >
        <div class="col"
          v-for="(field, index) in fieldsToRender[row]"
          :key="`column-${field.layout.property}-${index}`"
        >
          <custom-form-field
            :fieldLayout="field.layout"
            :fieldMetadata="field.metadata"
            :modelValue="formData[field.layout.property]"
            :error="$v.formData[field.layout.property]"
            :path="[field.layout.property]"
            :formDataCopy="formData"
            :showRemoveImageBtn="showRemoveImageBtn"
          />
        </div>
      </div>
    </div>
    <v-btn v-if="showSubmitButton" @click="submitForm">Submit</v-btn>
  </div>
</template>

<script>
// To get formData listen @submit event on formInterpretator component where u use it (on tag)
import { assoc, assocPath, clone, pathOr } from 'ramda'
import { required, numeric, email, url, maxLength } from 'vuelidate/lib/validators'
import validateLetter from '@/utils/validators/isLetter'
import CustomFormField from './NewCustomFormField'

export default {
  name: 'FormInterpretator',
  components: {
    CustomFormField,
    validateLetter
  },
  props: {
    name: {
      type: String,
      default: 'Form'
    },
    showRemoveImageBtn: {
      type: Boolean,
      default: true
    },
    formType: {
      type: String,
      default: 'form_type'
    },
    formId: {
      type: String,
      default: 'id-of-form'
    },
    formGroup: {
      type: String,
      default: undefined
    },
    formFields: {
      type: Array,
      default: () => ([])
    },
    formMetadata: {
      type: Object,
      default: () => ({})
    },
    editableItem: {
      type: Object,
      default: () => ({})
    },
    showSubmitButton: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fieldsToRender: {},
      formData: {},
      formValidators: { formData: {}},
      validationConfig: {
        required: {
          name: 'required',
          func: required
        },
        alpha: {
          name: 'alpha',
          func: validateLetter
        },
        number: {
          name: 'numeric',
          func: numeric
        },
        email: {
          name: 'email',
          func: email
        },
        url: {
          name: 'url',
          func: url
        },
        range: {
          name: 'maxLength',
          func: maxLength
        }
      }
    }
  },
  validations () {
    return this.formValidators
  },
  methods: {
    setFieldsToRender (form) {
      const result = {}

      // add rows
      form.forEach(field => {
        const row = field.layout.row
        if (!result.hasOwnProperty(row)) result[row] = []
        result[row].push(field)
      })

      // sort in rows by column
      Object.keys(result).forEach(row => {
        result[row] = result[row].sort((a, b) => a.layout.column - b.layout.column)
      })

      return result
    },
    getValidators (from) {
      return from.reduce((validationObj, validator) => {
        if (validator.name !== 'objectId') {
          if (validator.name === 'range') {
            validationObj[this.validationConfig[validator.name].name] = this.validationConfig[validator.name].func(validator.data.max)
          } else {
            validationObj[this.validationConfig[validator.name].name] = this.validationConfig[validator.name].func
          }
        }
        return validationObj
      }, {})
    },
    generateDataModel (from, to, toIsArray = false, itemsInArray, arrayName) {
      return from.reduce((acc, field) => {
        if (toIsArray) {
          for (let i = 0; i < itemsInArray; i++) {
            acc[i] = assoc(
              [field.layout.property],
              pathOr(field.layout.defaultValue, ['metadata', arrayName, i, field.layout.property], this.editableItem) || null,
              acc[i]
            )

            if (field.layout.validators.length) {
              this.formValidators.formData[arrayName][i] = assoc(
                [field.layout.property],
                this.getValidators(field.layout.validators),
                this.formValidators.formData[arrayName][i]
              )
            }
          }
        } else {
          acc[field.layout.property] = pathOr(
            field.layout.defaultValue,
            ['metadata', field.layout.property],
            this.editableItem
          ) || null

          if (field.layout.validators.length) {
            this.formValidators.formData[field.layout.property] = this.getValidators(field.layout.validators)
          }
        }

        if (field.layout.type === 'array') {
          acc[field.layout.property] = []
          this.formValidators.formData[field.layout.property] = {}
          this.generateDataModel(
            field.layout.fields, // from
            acc[field.layout.property], // to
            true, // new prop is array
            field.layout.validators[0].data.max, // how many items are in array
            field.layout.property
          )
        }

        return acc
      }, to)
    },
    submitForm () {
      this.$v.formData.$touch()
      if (this.$v.formData.$invalid) return
      this.$emit('submit', this.formData)
    }
  },
  mounted () {
    if (this.formFields && this.formFields.length) {
      this.fieldsToRender = this.setFieldsToRender(this.formFields)
      this.formData = clone(this.generateDataModel(this.formFields, this.formData))
    }
    this.$bus.$on('customFormInput', e => this.formData = assocPath(e.path, e.value, this.formData))
  },
  destroyed () {
    this.$bus.$off('customFormInput')
  }
}
</script>

<style lang="scss" scoped>
  .row {
    display: flex;
    flex-direction: row;
  }

  .col {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/EvFormInterpretator/index.vue